import { IFallbackContext } from '@site-shared/mfe';

export const defaultFallbackContext: IFallbackContext = {
	canRedirect: true,
	redirectPath: '/',
	supportCurtainName: 'help',
};
